/*
 * Paylaşılan pill buton sınıf üreticisi — Button component'i ve site
 * genelindeki <a> tabanlı CTA'lar (Navbar, FloatingRegisterButton) bunu
 * paylaşır, hepsi tek kaynaktan tutarlı görünür. Mimari sınav.uz'un
 * buttonStyles() sisteminden alındı, Butik Sıcaklık paletiyle uygulandı.
 */

// Mobbin.com'dan ölçülen gerçek değerler: dolu buton padding 11px/16px,
// font-weight 600, radius 999px — md boyutu bu ölçüme kasıtlı olarak yakın.
const SIZES = {
    sm: 'gap-1.5 px-3.5 py-1.5 text-sm',
    md: 'gap-2 px-4 py-2.5 text-[15px]',
    lg: 'gap-2 px-6 py-3 text-base',
    xl: 'gap-2.5 px-8 py-3.5 text-lg',
};

const VARIANTS = {
    primary: 'border-transparent bg-primary text-white shadow-lg shadow-primary/30 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-primary/40',
    secondary: 'border-transparent bg-secondary text-white shadow-lg shadow-secondary/30 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-secondary/40',
    outline: 'border-current bg-transparent hover:bg-black/5 dark:hover:bg-white/10',
    soft: 'border-transparent bg-primary/10 text-primary hover:bg-primary/15',
    white: 'border-transparent bg-white text-primary shadow-lg hover:bg-gray-100',
};

export function buttonStyles({ variant = 'primary', size = 'md', fullWidth = false, className = '' } = {}) {
    return [
        'inline-flex select-none items-center justify-center whitespace-nowrap rounded-full border font-semibold',
        'cursor-pointer transition-all duration-200 ease-out',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-gray-950',
        'disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none',
        SIZES[size],
        VARIANTS[variant],
        fullWidth && 'w-full',
        className,
    ].filter(Boolean).join(' ');
}
